export default "__VITE_ASSET__ee2daba7__"